<template>
    <div class="box">
        <div class="box-body">
            <TemplateManagerTemplate
                v-if="isReady"
                v-bind:id="template.Id"
                v-bind:name="template.Name"
                v-bind:subject="template.Subject"
                v-bind:sender="template.Sender"
                v-bind:sender-name="template.SenderName"
                v-bind:custom-css="template.Metadata.customCss"
                v-bind:locked="template.IsLocked"
                v-bind:pages="template.Pages"
                v-bind:templates="templateList"
                v-bind:parentId="template.ParentId"
                v-bind:created="parsedCreated"
                v-bind:modified="parsedModified"
                v-bind:state="template.State"
                v-bind:metadata="template.Metadata"
                v-on:change-name="template.Name = $event"
                v-on:change-subject="template.Subject = $event"
                v-on:change-sender="template.Sender = $event"
                v-on:change-sender-name="template.SenderName = $event"
                v-on:change-custom-css="template.Metadata.customCss = $event"
                v-on:set-parent="setParent($event)"
                v-on:lock-template="toggleTemplateLock($event)"
            >
                <div class="row mt-2">
                    <div class="col-11 mx-auto">
                        <div class="row">
                            <div class="col-12 mb-2">
                                <template-browser-preview-button
                                    v-if="!isNewTemplate"
                                        
                                    class="pull-right"
                                    v-bind:template-id="template.Id"
                                >
                                </template-browser-preview-button>
                            </div>
                            
                            <div class="col-12">
                                <button
                                        v-on:click="saveTemplateAsPublishable"
                                        class="btn btn-primary pull-right ml-3"
                                >
                                    {{resource('TemplateManager_SaveButton_Publishable_Text')}}
                                </button>

                                <button
                                        v-if="canSaveAsDraft"
                                        v-on:click="saveTemplateAsDraft"
                                        class="btn btn-primary pull-right"
                                >
                                    {{resource('TemplateManager_SaveButton_Draft_Text')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </TemplateManagerTemplate>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    
    import templateStates from '../template-states';

    import {applyDefaults, templateDefaults, pageDefaults, blockDefaults, rowDefaults, columnDefaults} from "../defaults";

    import resourceMixin from "../../../Util/Mixins/resources";
    import guidMixin from "../../../Util/Mixins/guid";

    import TemplateBrowserPreviewButton from "./TemplateBrowserPreviewButton.vue";
    import Template from './Template.vue';
    import growler from '../../../Util/growler';
    import templateApi from '../../../Api/template-manager';
    import _ from 'lodash';

    export default {
        name: 'template-manager',
        mixins: [resourceMixin, guidMixin],
        components: {
            'TemplateManagerTemplate': Template,
            TemplateBrowserPreviewButton
        },
        created () {
            const vm = this;
            const id = vm.id;

            templateApi.getTemplate(id).then((template) => {
                vm.deserializeMetadata(template);
                vm.template = template;
            });


            var templates = [{id: null, name:'--Select parent template--'}];

            templateApi.getParentTemplateList(id).then((list) => {
                list.forEach(function (template) {
                    if(template.Id.toUpperCase() !== id.toUpperCase()) {
                        templates.push({ id: template.Id, name: template.Name });
                    }
                });
            });

            vm.templateList = templates;
        },
        methods: {
            setParent(id) {
                const vm = this;
                
                if(id === null) {
                    vm.template.ParentId = null;
                    vm.template.Pages = [];
                } else {
                    templateApi.getTemplate(id, true).then((template) => {
                        vm.deserializeMetadata(template);
                        
                        //Mark our new template as parent
                        vm.template.ParentId = id;

                        //Copy all properties relevant to our actual template/rendering of the template
                        vm.template.PermissionId = template.PermissionId;
                        vm.template.Metadata = template.Metadata;
                        vm.template.IsLocked = template.IsLocked;
                        vm.template.Pages = template.Pages;

                        //Properties that are simply empty by default should be inherited unless the user
                        //has explicitly filled them
                        vm.template.Subject = vm.template.Subject || template.Subject;
                        vm.template.Sender = vm.template.Sender || template.Sender;
                        vm.template.SenderName = vm.template.SenderName || template.SenderName;
                    });
                }
            },
            saveTemplateAsDraft(){
                const vm = this;
                vm.template.State = templateStates.draft;
                
                return vm.saveTemplate();
            },
            saveTemplateAsPublishable(){
                const vm = this;
                vm.template.State = templateStates.publishable;
                
                return vm.saveTemplate();
            },
            saveTemplate() {
                const vm = this;
                const isNewTemplate = vm.isNewTemplate;
                
                vm.template.Modified = new Date();

                templateApi.saveTemplate(vm.serializeModel(vm.template)).then((data) => {
                    if(data.errors.length !== 0) {
                        growler.bootstrapDanger(data.errors.join('<br />'));
                        return;
                    } else {
                        if(isNewTemplate) {
                            window.history.pushState(null,'Template',`${data.value.Id}`);
                        }

                        vm.template = data.value;
                        vm.deserializeMetadata(vm.template);
                        growler.bootstrapSuccess(vm.resource('TemplateManager_SaveSuccess_Message'));
                        $('.settings:not(.template-settings)').remove();
                    }
                });
            },
            serializeModel(model) {
                model = _.cloneDeep(model);

                model.Metadata = JSON.stringify(model.Metadata);
                model.Pages.forEach(function(page) {
                    page.Metadata = JSON.stringify(page.Metadata);
                    
                    page.Blocks.forEach(function(block) {
                        block.Metadata = JSON.stringify(block.Metadata);
                        block.Rows.forEach(function(row) {
                            row.Metadata = JSON.stringify(row.Metadata);
                            row.Columns.forEach(function(column) {
                                column.Metadata = JSON.stringify(column.Metadata);
                            });
                        });
                    });
                });
                
                return model;
            },
            deserializeMetadata(model) {
                const vm = this;

                model.Metadata = applyDefaults(templateDefaults, JSON.parse(model.Metadata));
                
                model.Pages.forEach(function(page) {
                    page._key = vm.guid();
                    page.Metadata = applyDefaults(pageDefaults, JSON.parse(page.Metadata));
                    page.Blocks.forEach(function(block) {
                        block._key = vm.guid();
                        block.Metadata = applyDefaults(blockDefaults, JSON.parse(block.Metadata));
                        block.Rows.forEach(function(row) {
                            row._key = vm.guid();
                            row.Metadata = applyDefaults(rowDefaults, JSON.parse(row.Metadata));
                            row.Columns.forEach(function(column) {
                                column._key = vm.guid();
                                column.Metadata = applyDefaults(columnDefaults, JSON.parse(column.Metadata));
                            });
                        });
                    });
                });
            },
            parseDate(dateStr){ 
                return moment.utc(dateStr)
                    .local().toDate();
            },
            toggleTemplateLock(locked) {
                this.template.IsLocked = locked;
                this.template.LockStateChanged = !this.template.LockStateChanged;
            }
        },
        computed: {
            isReady() {
                return this.template != null && this.templateList != null;
            },
            isNewTemplate(){
                const vm = this;
                return vm.template && vm.template.Id === vm.emptyGuid();
            },
            parsedCreated(){
                return this.parseDate(this.template.Created);
            },
            parsedModified(){
                return this.parseDate(this.template.Modified);
            },
            canSaveAsDraft(){
                return this.template.State === templateStates.draft;
            }
        },
    	data() { 
            return {
                template: null,
                templateList: null
            }
        },
        props: {
            id: {
                type: String,
                required: true
            }
        }
    };
</script>


<style scoped src="../Style/template-manager.scss" lang="scss">
</style>
